module.exports = function () {
  return new Worker(__webpack_public_path__ + "3872d50d489248c285f5.worker.js");
};